<div class="flex flex-col">
  <nz-form-label nzFor="key">{{ to.label }}</nz-form-label>
  <label nz-checkbox  [formControl]="formControl" [formlyAttributes]="field" ></label>
</div>
